import React, { useEffect, useRef, useState } from "react";
import styles from "../chatLeftSideBar.module.scss";
import facedenied from '../../../../../styles/images/facedenied.svg';
import Success from '../../../../../styles/images/Success.svg';
import Recapture from '../../../../../styles/images/recaptureimg.svg';
import { Modal,Tabs, Radio, Checkbox } from "antd";
import store from "../../../../../store/redux-store/root_store";
import _ from "lodash";
import { CoreServices } from "../../../../../base/service/apiServices";
import { videoCallService } from "../../../../../base/service/videoCallService";
import axios from "axios";
import { toast } from "../../../../../annotation";
import { config } from "../../../../../base/constant";
import { dataURLtoBlob, sendDocToNlp, setDocModal, setVerificationDetails, setVerifyInitialState, setVerifyModals, setVerifyMsg, updateImage, updateVerificationFailure, uploadImage } from "../../../../../base/video_common";
import { meetActionTypes } from "../../../../../base/action/action";
function Verificationmodal() {
    let stored_Video = store.getState().storeVideo;
    let participantVideo: any = useRef(null);
    let { verifyReqModal,imgCount,imgFile,isFace,isDocs,isFaceDocs,isStore,isVerify,verifyAcceptModal,faceRecogModal,faceImgUrl,docImgUrl,verifyErrMsg,verifySuccessMsg,dataProcessing,verifyContent,verifyAttachments ,
      docModal,docCaptureModal,docSendDetails,docReceiveDetails,docDetailsModal,faceCaptureModal} = store.getState().verificationReducer;
    const {currdeviceinfo,activeParticipantList,meetingDetails } = store.getState().meetingReducer;
    let remotedev: any = activeParticipantList.find((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
    const { TabPane } = Tabs;
    let customerdetails: any = activeParticipantList.filter((ele: any) => { return (ele.isGuest  && !ele.conId.includes("_screenshare"))})
    const [start, setStart] = useState(false);
    const [verifyCheck,setVerifyCheck]=useState(false);
    const [cancelModal, setCancelModal] = useState(false);
    const [isInstruction, setIsInstruction] = useState(false);
     const [doc, setDoc] = useState("");
        let timeInterval: any = useRef(null);
        let canvasRef:any=useRef(null);
    useEffect(() => {
     try{ if (customerdetails[0]?.status === "joined") {
        let videoData: any = _.find(stored_Video.participantList, { participants: customerdetails[0]?.conId });
       if(participantVideo.current){ if (videoData !== undefined && videoData.stream !== '') {
          if ((participantVideo.current.srcObject === null)
            || (participantVideo.current.srcObject.id !== videoData.stream.id)) {
            participantVideo.current.srcObject = videoData.stream;
          }
        }}
      }
      }
      catch(err:any){
      console.log("video stream error")
      }
    }, [activeParticipantList, stored_Video, stored_Video.participantList.length, activeParticipantList.length,JSON.stringify(currdeviceinfo),faceRecogModal,docCaptureModal,faceImgUrl,dataProcessing,verifyErrMsg,verifySuccessMsg,verifyContent,docDetailsModal,docImgUrl])

      const consentCheckBox=(e:any)=>{
    setVerifyCheck(e.target.checked)
  }

  useEffect(()=>{
   CoreServices.get(`/get_customer_conatct_details/${meetingDetails.agentDetails.customerDetails.coid}`).then((value:any) => {
    if (value && value.data.statusCode === 200) {
      const customerFullData = value.data.getContactDetailsRes[0];
      if(customerFullData?.attachments!== null){
        store.dispatch({
           type:meetActionTypes.VERIFICATION_ATTACHMENTS,
           payload:{verifyAttachments:(JSON.parse(customerFullData.attachments))}
        })}
    }
  })
  },[])
  
  const handleTabChange=(key:any)=>{
     if(key === "verify") setVerificationDetails(false,true,true,false,false)
      else setVerificationDetails(true,false,true,false,false)
  }

    const sendVerificationReq=()=>{
    let data:any={type:"req",isFace,isDocs,isFaceDocs,isStore,isVerify,deviceid:remotedev?.deviceid};
    videoCallService.sendVerificationRequestData(data);
     setVerifyModals(true,false,false,false,false,false)
  }

   const closeModal=()=>{
  setVerifyCheck(false);
  setVerifyInitialState();
}

      useEffect(()=>{
        try {
          if (start) {
            timeInterval = setInterval(() => {
                  const formData = new FormData();
                  if (imgCount === 1) {
                      formData.append('doc', imgFile.file1);
                  } else if (imgCount === 2) {
                      formData.append('doc', imgFile.file2);
                  } else if (imgCount === 3) {
                      formData.append('doc', imgFile.file3);
                  } else if (imgCount === 4) {
                      formData.append('doc', imgFile.file4);
                  } else if (imgCount === 5) {
                      formData.append('doc', imgFile.file5);
                  }
                      axios.post(`${config().FACE_DETECTION}`, formData).then(async (res: any) => { 
                          
                          if (res.data.message === 'No face found') {
                              if (start) {
                                  faceCapture(imgCount)
                              } else {
                                  faceCapture(1)
                              }
                              
                          } else if (res.data.message === 'Face detected') {
                            console.log("face detected");
                              if (start && imgCount < 7) {
                                  faceCapture(imgCount + 1)
                              }
                          } else if (res.data.message === 'Multiple face detected') {
                            console.log("Multiple face detected");
                              if (start) {
                                  faceCapture(imgCount)
                              } else {
                                  faceCapture(1)
                              }
                          }
                          else if (res.data.message === 'Low lighting') {
                            console.log("Low lighting");
                              if (start) {
                                  faceCapture(imgCount)
                              } else {
                                  faceCapture(1)
                              }
                          } 
                           else if (res.data.message === 'Failure') {
                            clearInterval(timeInterval)
                            toast('Error detecting face')
                            updateVerificationFailure("face");
                          }
                      }).catch((err: any) => {
                          console.log('err:', err)
                          setStart(false)
                          clearInterval(timeInterval);
                          toast('Error detecting face')
                          updateVerificationFailure("face");
                      })
                  
              }, 2500)
              return () => clearInterval(timeInterval);
          }
      } catch (error) {
          console.log('interval error:', error)
          clearInterval(timeInterval);
          updateVerificationFailure("face");
          setStart(false)
      }
      },[ imgCount, imgFile,start])

      const changeVerifyType=(e:any)=>{
        if(e.target.value  === "1") setVerificationDetails(isStore,isVerify,true,false,false)
          else if(e.target.value ==="2")  setVerificationDetails(isStore,isVerify,false,true,false)
        else   setVerificationDetails(isStore,isVerify,false,false,true)
      }

        const faceCapture=async(idx:any)=>{
    try{
    if(Array.isArray(customerdetails) && customerdetails?.length > 0){
      updateImage(idx,imgFile,"","")
      const meetingDetails: any = store.getState().meetingReducer;
        let data:any={count:idx,deviceid:customerdetails[0]?.deviceid};
      videoCallService.sendVerificationDetails(data);
    const video = participantVideo.current;
    const canvas = canvasRef.current;
    if (video && canvas) {
        const context = canvas.getContext('2d');
        const targetWidth = 640;
        const targetHeight = 480;
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        context.drawImage(video, 0, 0, targetWidth,targetHeight);
        const dataURL = canvas.toDataURL('image/jpg', 0.9);
        const blob = await dataURLtoBlob(dataURL);
        const file = new File([blob],`${meetingDetails.meetingDetails.agentDetails.customerNumber}_${JSON.stringify(meetingDetails.meetingDetails.agentDetails.customerDetails.coid)}_${JSON.stringify(meetingDetails.meetingDetails.agentDetails.domain_id)}_${idx}.jpg`, { type: 'image/jpg' });
        let updatedInfo: any = imgFile;
        updatedInfo = {
          ...updatedInfo, [`file${idx}`]: file
        };
        updateImage(idx,updatedInfo,"","")
        if (start && imgCount < 6) {
          if (imgCount === 5) {
            setStart(false)
              updateImage(idx,updatedInfo,dataURL,"")
              setVerifyMsg(isStore ?  "Face verification completed": (isVerify && customerdetails[0]?.conId === currdeviceinfo.conId ? "Face verification completed" : "Ready"),"","",false)
                return;
            }
        }
      }}
    }
    catch(err:any){
      updateVerificationFailure("face");
    }
      }
  const declineReq=()=>{
    setVerifyModals(true,false,false,true,false,false);
  }
    const acceptVerificationRequest=()=>{
    const{currdeviceinfo}=store.getState().meetingReducer;
    let data:any={type:"res",isStore,isVerify,isFace,isFaceDocs,isDocs,deviceid:currdeviceinfo.deviceid,isAccept:true};
    videoCallService.sendVerificationRequestData(data);
  }

    const captureImage=()=>{

      if(isVerify){  const formData = new FormData();
        formData.append('doc', imgFile.file1);
        axios.post(`${config().FACE_RECOGNITION}`, formData).then((res: any) => {
            if (res.data.message === 'Success') {
                setVerifyModals(true,false,false,false,false,true)
     let data:any={count:imgCount,deviceid:customerdetails[0]?.deviceid,faceImgUrl,isImageCaptured:true,verifyType:"face"};
           videoCallService.sendVerificationDetails(data);
            } else if (res.data.message === 'Failure') {
              setVerifyModals(true,false,false,false,false,true)
               if(isFace || isFaceDocs){
                setVerifyMsg("","Face verification failed","",false)
              }
            }
        })}
        else{
                setVerifyModals(true,false,false,false,false,true)
     let data:any={count:imgCount,deviceid:customerdetails[0]?.deviceid,faceImgUrl,isImageCaptured:true,verifyType:"face"};
           videoCallService.sendVerificationDetails(data);
        }
  }

    const sendImageToAi=async ()=>{
    try {
      updateImage(0,imgFile,faceImgUrl,"")
      const formData = new FormData();
      formData.append('doc', imgFile.file1);
      formData.append('doc', imgFile.file2);
      formData.append('doc', imgFile.file3);
      formData.append('doc', imgFile.file4);
      formData.append('doc', imgFile.file5);
      if(isStore){
          setVerifyMsg("","","Processing data",true)
      const formDataRes = await axios.post(`${config().FACE_UPLOAD_IMAGE}`, formData)
     if (formDataRes && formDataRes?.data?.message === 'Success') {
        uploadImage(imgFile.file5,"face")
      } else if (formDataRes && formDataRes?.data?.message === 'Failure') {
       toast("Failed to save verification data. Please try again later.");
       updateVerificationFailure("face")
      }}
      else{
        if(verifyErrMsg){updateVerificationFailure("face")}
        else{
        if(isFace){   let data:any={type:"complete", verifyType:"face",deviceid:remotedev?.deviceid};
                           videoCallService.sendVerificationRequestData(data);}
                                       else if(isFaceDocs){
                                         setVerifyModals(true,false,false,false,false,false);
                                         setDocModal(true,{},[],false,false)
            }
        }
      }
  } catch (error) {
    toast("Unable to verify face");
    console.log("errrrrrrrrrr",error);
 
  }
  }

    const cancelModalConfirm=()=>{
    setCancelModal(false);
    setStart(false);
    setVerifyCheck(false);
    let data:any={};
    data.type="cancel";
    data.deviceid=customerdetails[0]?.deviceid;
    videoCallService.sendVerificationRequestData(data);
  }

  const setDocType=(type:any)=>{
    setDoc(type)
  }

  const getStarted=()=>{
     let data:any={type:doc}
     setDocModal(false,data,[],true,false)
    let senddata:any={type:"doccapture",isStore,isVerify,isFace,isFaceDocs,isDocs,deviceid:currdeviceinfo.deviceid,isAccept:true};
    videoCallService.sendVerificationRequestData(senddata);
  }
  const docCapture=async()=>{
 if(Array.isArray(customerdetails) && customerdetails?.length > 0){
      const meetingDetails: any = store.getState().meetingReducer;
        let data:any={count:imgCount+1,deviceid:customerdetails[0].deviceid};
      videoCallService.sendVerificationDetails(data);
    const video = participantVideo.current;
    const canvas = canvasRef.current;
    if (video && canvas) {
        const context = canvas.getContext('2d');
        const targetWidth = 640;
        const targetHeight = 480;
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        context.drawImage(video, 0, 0, targetWidth,targetHeight);
        const dataURL = canvas.toDataURL('image/jpg', 0.9);
        const blob = await dataURLtoBlob(dataURL);
        const file = new File([blob],`${JSON.stringify(meetingDetails.meetingDetails.agentDetails.customerDetails.coid)}_${JSON.stringify(meetingDetails.meetingDetails.agentDetails.domain_id)}.jpg`, { type: 'image/jpg' });
        sendDocToNlp(dataURL,file);
      }}
  }

  const updateFailure=()=>{
    updateVerificationFailure("face")
  }

  const completeVerification=()=>{
                let data:any={type:"complete", verifyType:"face",deviceid:remotedev?.deviceid};
                           videoCallService.sendVerificationRequestData(data);
  }

  return (
    <>
      {/* radiobox */}
       <Modal
           title="Verification method"
          open={verifyReqModal}
          className="customModal sizeMD customerbutton"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16" onClick={setVerifyInitialState}></span>}
          footer={[
              <div className={styles.poweredsvgbtn}>
                 <p>Powered by<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                 <path d="M14.0002 2.54995V9.35183H9.29819V7.25073C9.29819 5.84337 8.156 4.70134 6.74788 4.70134H4.64648V0H11.4499C12.858 0 14.0002 1.14148 14.0002 2.54995Z" fill="#e6e4eb"/>
                 <path d="M9.29891 9.35156V13.9998L4.64941 9.35156H9.29891Z" fill="#e6e4eb"/>
                 <path d="M9.29844 7.25008C9.29844 5.84216 8.1568 4.70068 6.74868 4.70068H4.64729L4.64895 4.70234H0V9.35062H4.64895V4.70289L9.29789 9.35117V7.25008H9.29844Z" fill="black"/>
                 </svg><svg xmlns="http://www.w3.org/2000/svg" width="57" height="12" viewBox="0 0 57 12" fill="none">
                 <path d="M10.819 0.84082L9.34378 6.16544L7.97923 1.03437H5.60014L4.23559 6.16544L2.73256 0.84082H0.27832L3.13198 11.0487H4.95161L6.78934 5.79297L8.61315 11.0487H10.4467L13.3004 0.84082H10.819ZM15.7094 4.0413C13.7513 4.0413 12.1522 5.64119 12.1522 7.60033C12.1522 9.55947 13.7513 11.1594 15.7094 11.1594C17.6675 11.1594 19.2665 9.55947 19.2665 7.60033C19.2665 5.64119 17.6675 4.0413 15.7094 4.0413ZM15.7094 8.92452C14.9787 8.92452 14.3859 8.33135 14.3859 7.60033C14.3859 6.86931 14.9787 6.27614 15.7094 6.27614C16.44 6.27614 17.0329 6.86931 17.0329 7.60033C17.0329 8.33135 16.44 8.92452 15.7094 8.92452ZM34.4262 1.95824H32.1925V8.13781C32.1925 10.1519 33.2126 11.048 34.9912 11.048H36.3008V8.81313H35.0601C34.6739 8.81313 34.4262 8.53743 34.4262 8.16496V6.09582H36.3843V4.15061H34.4262V1.95754V1.95824ZM51.839 4.1513H49.9637V4.46878C49.4397 4.19238 48.8886 4.04061 48.2818 4.04061C46.3244 4.04061 44.7393 5.62657 44.7393 7.58571C44.7393 9.54485 46.3244 11.1587 48.2818 11.1587C48.9158 11.1587 49.4676 10.979 49.9915 10.7166V11.048H52.2718V9.02756H51.839V4.1513ZM48.3361 8.92383C47.6062 8.92383 47.0265 8.33066 47.0265 7.58571C47.0265 6.84077 47.6055 6.26082 48.3361 6.26082C49.0668 6.26082 49.6603 6.85399 49.6603 7.58571C49.6603 8.31743 49.0675 8.92383 48.3361 8.92383ZM55.9341 8.81313C55.6028 8.81313 55.4372 8.59243 55.4372 8.27496V1.39292H52.7714V3.41332H53.2043V8.24781C53.2043 10.193 53.9071 11.048 55.8652 11.048H56.4024V8.81313H55.9334H55.9341ZM21.6693 4.46808V4.15061H19.5275V6.17101H19.9603V11.0473H22.1661V7.07469C22.1661 6.62007 22.5391 6.26082 22.9935 6.26082H23.9029V4.15061H22.9107C22.4827 4.15061 22.0694 4.21953 21.6693 4.46808ZM31.5002 4.15061H28.8532L26.9688 5.98512V1.39292H24.3037V3.41332H24.7359V11.048H26.9695V9.0756L27.403 8.65509L29.1433 11.048H31.8453L28.8949 7.15824L31.5002 4.1513V4.15061ZM41.7604 8.10926C41.7604 8.56458 41.3881 8.93706 40.933 8.93706C40.478 8.93706 40.1064 8.56389 40.1064 8.10926V4.15061H37.4531V6.17101H37.8873V8.10926C37.8873 9.792 39.2519 11.158 40.9337 11.158C42.6156 11.158 43.9808 9.792 43.9808 8.10926V4.15061H41.7611V8.10926H41.7604Z" fill="black"/>
                 </svg></p>
                 <div className={styles.sendrequest}>
                  <button onClick={setVerifyInitialState}>Cancel</button>
                  <button onClick={sendVerificationReq}>Send request</button>
                 </div>
              </div>
          ]}
        >
         <div>
         <Tabs defaultActiveKey="verify" className="leftSidebarTab verficationtab" onChange={handleTabChange} activeKey={isVerify ? "verify" : "store"}>
                    <TabPane tab="Store data" key="store">
          <div className={styles.profileverificationts}>
            <div className={styles.profileverification}>
              <div className={`${styles.verficationtabradio} `}>
              <Radio.Group defaultValue={"1"}  className='verficationtabradiot' onChange={(e: any) => {changeVerifyType(e)}}>
              <Radio value={"1"} checked={isFace}>  Face</Radio>
              <Radio value={"2"} checked={isDocs}> Document</Radio>
              <Radio value={"3"} checked={isFaceDocs}>Face & Document</Radio>
              </Radio.Group>
              </div>
            </div>
            <p>Face verification is a security method that uses facial features to authenticate a customer's identity. It involves capturing and analyzing facial images to create a unique template for comparison with stored data, ensuring a secure and convenient means of identity confirmation.</p>
            </div>
          </TabPane>
          {verifyAttachments !== null && verifyAttachments?.length > 0 && 
          <TabPane tab="Verification" key="verify">
            <div className={styles.profileverificationts}>
            <div className={styles.profileverification}>
              <div className={`${styles.verficationtabradio} `}>
              <Radio.Group defaultValue={"1"} className='verficationtabradiot' onChange={(e: any) => {changeVerifyType(e)}}>
              <Radio value={"1"} checked={isFace}>  Face</Radio>
              <Radio value={"2"} checked={isDocs}> Document</Radio>
              <Radio value={"3"} checked={isFaceDocs}>Face & Document</Radio>
              </Radio.Group>
              </div>
            </div>
            <p>Face verification is a security method that uses facial features to authenticate a customer's identity. It involves capturing and analyzing facial images to create a unique template for comparison with stored data, ensuring a secure and convenient means of identity confirmation.</p>
            </div>
          </TabPane>}
          </Tabs>
         </div>
        </Modal>
      {/* agreement modal */}
      <Modal
           title="Privacy consent"
          open={verifyAcceptModal}
          className="customModal sizeMD customerbutton"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16"></span>}
          footer={[
              <div className={styles.poweredsvgbtn}>
                 <p>Powered by<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                 <path d="M14.0002 2.54995V9.35183H9.29819V7.25073C9.29819 5.84337 8.156 4.70134 6.74788 4.70134H4.64648V0H11.4499C12.858 0 14.0002 1.14148 14.0002 2.54995Z" fill="#e6e4eb"/>
                 <path d="M9.29891 9.35156V13.9998L4.64941 9.35156H9.29891Z" fill="#e6e4eb"/>
                 <path d="M9.29844 7.25008C9.29844 5.84216 8.1568 4.70068 6.74868 4.70068H4.64729L4.64895 4.70234H0V9.35062H4.64895V4.70289L9.29789 9.35117V7.25008H9.29844Z" fill="black"/>
                 </svg><svg xmlns="http://www.w3.org/2000/svg" width="57" height="12" viewBox="0 0 57 12" fill="none">
                 <path d="M10.819 0.84082L9.34378 6.16544L7.97923 1.03437H5.60014L4.23559 6.16544L2.73256 0.84082H0.27832L3.13198 11.0487H4.95161L6.78934 5.79297L8.61315 11.0487H10.4467L13.3004 0.84082H10.819ZM15.7094 4.0413C13.7513 4.0413 12.1522 5.64119 12.1522 7.60033C12.1522 9.55947 13.7513 11.1594 15.7094 11.1594C17.6675 11.1594 19.2665 9.55947 19.2665 7.60033C19.2665 5.64119 17.6675 4.0413 15.7094 4.0413ZM15.7094 8.92452C14.9787 8.92452 14.3859 8.33135 14.3859 7.60033C14.3859 6.86931 14.9787 6.27614 15.7094 6.27614C16.44 6.27614 17.0329 6.86931 17.0329 7.60033C17.0329 8.33135 16.44 8.92452 15.7094 8.92452ZM34.4262 1.95824H32.1925V8.13781C32.1925 10.1519 33.2126 11.048 34.9912 11.048H36.3008V8.81313H35.0601C34.6739 8.81313 34.4262 8.53743 34.4262 8.16496V6.09582H36.3843V4.15061H34.4262V1.95754V1.95824ZM51.839 4.1513H49.9637V4.46878C49.4397 4.19238 48.8886 4.04061 48.2818 4.04061C46.3244 4.04061 44.7393 5.62657 44.7393 7.58571C44.7393 9.54485 46.3244 11.1587 48.2818 11.1587C48.9158 11.1587 49.4676 10.979 49.9915 10.7166V11.048H52.2718V9.02756H51.839V4.1513ZM48.3361 8.92383C47.6062 8.92383 47.0265 8.33066 47.0265 7.58571C47.0265 6.84077 47.6055 6.26082 48.3361 6.26082C49.0668 6.26082 49.6603 6.85399 49.6603 7.58571C49.6603 8.31743 49.0675 8.92383 48.3361 8.92383ZM55.9341 8.81313C55.6028 8.81313 55.4372 8.59243 55.4372 8.27496V1.39292H52.7714V3.41332H53.2043V8.24781C53.2043 10.193 53.9071 11.048 55.8652 11.048H56.4024V8.81313H55.9334H55.9341ZM21.6693 4.46808V4.15061H19.5275V6.17101H19.9603V11.0473H22.1661V7.07469C22.1661 6.62007 22.5391 6.26082 22.9935 6.26082H23.9029V4.15061H22.9107C22.4827 4.15061 22.0694 4.21953 21.6693 4.46808ZM31.5002 4.15061H28.8532L26.9688 5.98512V1.39292H24.3037V3.41332H24.7359V11.048H26.9695V9.0756L27.403 8.65509L29.1433 11.048H31.8453L28.8949 7.15824L31.5002 4.1513V4.15061ZM41.7604 8.10926C41.7604 8.56458 41.3881 8.93706 40.933 8.93706C40.478 8.93706 40.1064 8.56389 40.1064 8.10926V4.15061H37.4531V6.17101H37.8873V8.10926C37.8873 9.792 39.2519 11.158 40.9337 11.158C42.6156 11.158 43.9808 9.792 43.9808 8.10926V4.15061H41.7611V8.10926H41.7604Z" fill="black"/>
                 </svg></p>
                 <div className={styles.sendrequest}>
                  <button onClick={declineReq}>Decline</button>
                  <button  onClick={acceptVerificationRequest} className={!verifyCheck ? "verifydisable" : ""}>Accept</button>
                 </div>
              </div>
          ]}
        >

          
         <div className={`${styles.collectionpro} ${styles.collectionproinformation}`}>
            <p>I agree to the collection, processing, and/or storage of my personal information by Worktual application for the purpose of identity verification, and that the information I provide is true and accurate to the best of my knowledge and I shall be fully responsible in case I provide wrong information or any of the documents I use are fake, forged, counterfeit etc</p>
            <label className={styles.processingabove}> <Checkbox checked={verifyCheck} onChange={(e:any)=>consentCheckBox(e)}></Checkbox> I agree with the above statement and Worktual's privacy policy</label>
         </div>
        </Modal>
      {/* verification steps */}
             <Modal
          title="Face Capture"
          open={faceRecogModal && customerdetails[0]?.conId !== currdeviceinfo.conId}
          className="customModal  customerbutton detailsheigh"
          centered
          footer={[
            <div className={`${styles.poweredsvgbtn} ${styles.poweredsvgbtnstart}`}>
              <div className={styles.sendrequest}>
                <button onClick={()=>{setCancelModal(true)}}>Cancel</button>
                {(imgCount === 0) ? <button onClick={()=>{setStart(true) 
                  faceCapture(1)}}>Start</button> : <button onClick={captureImage} className={imgCount < 6 ? "verifydisable" : ""} >Capture</button>}
              </div>
            </div>
          ]}
        >
  {imgCount > 5 &&  <div className={styles.smsotpcontainersvg}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.4771 0 0 4.4771 0 10C0 15.5229 4.4772 20 10 20C15.5228 20 20 15.5227 20 10C20 4.4773 15.5228 0 10 0ZM14.7787 7.2161L10.2518 13.1116C9.8539 13.6302 9.2513 13.9485 8.5985 13.9866C8.555 13.9895 8.5111 13.9905 8.4676 13.9905C7.8607 13.9905 7.2786 13.7464 6.8529 13.3079L5.2782 11.6858C4.9896 11.3889 4.9965 10.9133 5.2938 10.6253C5.5911 10.3373 6.0663 10.345 6.3543 10.6409L7.929 12.263C8.0833 12.4212 8.2806 12.5062 8.5115 12.4896C8.7322 12.4769 8.9275 12.3734 9.0623 12.1976L13.5892 6.3021C13.8412 5.974 14.3138 5.9125 14.6405 6.1644C14.9691 6.4164 15.0311 6.887 14.7787 7.2161Z" fill="#000" />
          </svg> <p>{isStore ?  "Face Detection completed " :  isVerify ? "Ready" : "Face Detection completed" }</p></div>}
          <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
            <div className={styles.smsotpcontainer} >

            <video
                                     playsInline
                                     autoPlay
                                     ref={participantVideo}
                                     id={customerdetails[0]?.conId}
                                     preload={"auto"}
                                     style={{ display: currdeviceinfo.video ? "block" : "none"} }
                                     muted={true}
                                 />
                        { <canvas id="canvaverification" ref={canvasRef} style={{display:"none"}}></canvas>}
              <div className={`${styles.verfiyprocess} ${styles.verfiyprocessface} ${styles.modalprofbg} ${styles.modalproagent}`}>
                                            {imgCount &&
                                                <div className={
                                                  imgCount === 0 ?
                                                        "" :
                                                        imgCount === 1 ?
                                                            `` :
                                                            imgCount === 2 ?
                                                                `${styles.activeload} ${styles.active1}` :
                                                                imgCount === 3 ?
                                                                    `${styles.activeload} ${styles.active2}` :
                                                                    imgCount === 4 ?
                                                                        `${styles.activeload} ${styles.active3}` :
                                                                        imgCount === 5 ?
                                                                            `${styles.activeload} ${styles.active4}` :
                                                                            `${styles.activeload} ${styles.active4}`
                                                }>
                                                </div>
                                            }
                                            {/* {activeGreen && <div className={`${styles.activeload} ${styles.active4}`}></div>} */}
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          title="Face Capture"
          open={faceRecogModal && customerdetails[0]?.conId === currdeviceinfo.conId}
              className="customModal  customerbutton classfacemodalcustomer"
          centered
          footer={null}
        >
{imgCount > 5 &&  <div className={styles.smsotpcontainersvg}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.4771 0 0 4.4771 0 10C0 15.5229 4.4772 20 10 20C15.5228 20 20 15.5227 20 10C20 4.4773 15.5228 0 10 0ZM14.7787 7.2161L10.2518 13.1116C9.8539 13.6302 9.2513 13.9485 8.5985 13.9866C8.555 13.9895 8.5111 13.9905 8.4676 13.9905C7.8607 13.9905 7.2786 13.7464 6.8529 13.3079L5.2782 11.6858C4.9896 11.3889 4.9965 10.9133 5.2938 10.6253C5.5911 10.3373 6.0663 10.345 6.3543 10.6409L7.929 12.263C8.0833 12.4212 8.2806 12.5062 8.5115 12.4896C8.7322 12.4769 8.9275 12.3734 9.0623 12.1976L13.5892 6.3021C13.8412 5.974 14.3138 5.9125 14.6405 6.1644C14.9691 6.4164 15.0311 6.887 14.7787 7.2161Z" fill="#000" />
          </svg> <p>Face Detection completed</p></div>}
          <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
            <div className={styles.smsotpcontainer} >

            <video
                                     playsInline
                                     autoPlay
                                     ref={participantVideo}
                                     id={customerdetails[0]?.conId}
                                     preload={"auto"}
                                     style={{ display: currdeviceinfo.video ? "block" : "none"} }
                                     muted={true}
                                 />
              <div className={`${styles.verfiyprocess} ${styles.verfiyprocessface} ${styles.modalprofbg}`}>

                                                <div className={
                                                                         imgCount === 0 ?
                                                                         "" :
                                                                         imgCount === 1 ?
                                                                             `` :
                                                                             imgCount === 2 ?
                                                                                 `${styles.activeload} ${styles.active1}` :
                                                                                 imgCount === 3 ?
                                                                                     `${styles.activeload} ${styles.active2}` :
                                                                                     imgCount === 4 ?
                                                                                         `${styles.activeload} ${styles.active3}` :
                                                                                         imgCount === 5 ?
                                                                                             `${styles.activeload} ${styles.active4}` :
                                                                                             `${styles.activeload} ${styles.active4}`
                                                }>
                                                </div>
                                            
              </div>
              {imgCount === 0 && <div className={styles.verificationroundplace}>Place your face within the frame</div>}
            </div>
          </div>
        </Modal>
           <Modal
          title="Face Capture"
          open={customerdetails[0]?.conId !== currdeviceinfo.conId && faceCaptureModal}
          className="customModal sizeMD customerbutton"
          centered
          footer={(!dataProcessing) ? [
            <div className={styles.poweredsvgbtn}>
              <button onClick={acceptVerificationRequest}>Recapture</button>
              <div className={styles.sendrequest}>
                <button onClick={closeModal}>Cancel</button>
                {!verifyErrMsg ? <button onClick={sendImageToAi}>{isStore ? "Save" : "Done"}</button> : <button onClick={updateFailure}>{ "Done"}</button>}
              </div>
            </div>
          ] : null}
        >
          {faceImgUrl && !dataProcessing && verifyErrMsg === "" && <div className={styles.smsotpcontainersvg}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.4771 0 0 4.4771 0 10C0 15.5229 4.4772 20 10 20C15.5228 20 20 15.5227 20 10C20 4.4773 15.5228 0 10 0ZM14.7787 7.2161L10.2518 13.1116C9.8539 13.6302 9.2513 13.9485 8.5985 13.9866C8.555 13.9895 8.5111 13.9905 8.4676 13.9905C7.8607 13.9905 7.2786 13.7464 6.8529 13.3079L5.2782 11.6858C4.9896 11.3889 4.9965 10.9133 5.2938 10.6253C5.5911 10.3373 6.0663 10.345 6.3543 10.6409L7.929 12.263C8.0833 12.4212 8.2806 12.5062 8.5115 12.4896C8.7322 12.4769 8.9275 12.3734 9.0623 12.1976L13.5892 6.3021C13.8412 5.974 14.3138 5.9125 14.6405 6.1644C14.9691 6.4164 15.0311 6.887 14.7787 7.2161Z" fill="#000" />
          </svg> <p>Face verification completed</p></div>}
          {verifyErrMsg === "Face verification failed" && isVerify && (isFace || isFaceDocs) &&
                      <div className={`${styles.smsotpcontainersvg} ${styles.smsotpcontainersvgpara}`}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10.0002 0.00415039C4.47973 0.00415039 0.00439453 4.47949 0.00439453 9.99999C0.00439453 15.5205 4.47973 19.9958 10.0002 19.9958C15.5207 19.9958 19.9961 15.5205 19.9961 9.99999C19.9961 4.47949 15.5208 0.00415039 10.0002 0.00415039ZM14.3814 13.2104C14.6743 13.5033 14.6743 13.9777 14.3814 14.2705C14.235 14.4169 14.0431 14.4901 13.8513 14.4901C13.6595 14.4901 13.4677 14.4169 13.3212 14.2705L10.0003 10.9496L6.67941 14.2705C6.53297 14.4169 6.34115 14.4901 6.14933 14.4901C5.95751 14.4901 5.76569 14.4169 5.61925 14.2705C5.32638 13.9776 5.32638 13.5032 5.61925 13.2104L8.94017 9.88953L5.61925 6.56861C5.32638 6.27574 5.32638 5.80134 5.61925 5.50856C5.91213 5.21578 6.38654 5.21568 6.67931 5.50856L10.0002 8.82947L13.3211 5.50856C13.614 5.21568 14.0884 5.21568 14.3812 5.50856C14.674 5.80143 14.6741 6.27584 14.3812 6.56861L11.0603 9.88953L14.3814 13.2104Z" fill="#DE003D"/>
                    </svg> <p>Face verification failed</p></div>
          }
          { faceImgUrl && !dataProcessing && <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
            <img id="faceimg" src={faceImgUrl}/>
          </div>}
        { dataProcessing && isStore  && verifyContent==="Processing data" &&  <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
           <span className="loadercollection"></span>
           <h3>Processing data, please wait...</h3>
         </div>}

         {verifyContent=== "face stored successfully"   &&  isStore && <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
         <img src={Success} alt='successmsg'/>

          <h3>Face has been stored sucessfully</h3>
         </div>}
        </Modal>

        <Modal
          title="Face Capture"
          open={faceImgUrl && currdeviceinfo.conId === customerdetails[0]?.conId && isVerify && faceCaptureModal}
          className="customModal sizeMD customerbutton"
          centered
          footer={null}
        >
           <div className={styles.smsotpcontainersvg}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.4771 0 0 4.4771 0 10C0 15.5229 4.4772 20 10 20C15.5228 20 20 15.5227 20 10C20 4.4773 15.5228 0 10 0ZM14.7787 7.2161L10.2518 13.1116C9.8539 13.6302 9.2513 13.9485 8.5985 13.9866C8.555 13.9895 8.5111 13.9905 8.4676 13.9905C7.8607 13.9905 7.2786 13.7464 6.8529 13.3079L5.2782 11.6858C4.9896 11.3889 4.9965 10.9133 5.2938 10.6253C5.5911 10.3373 6.0663 10.345 6.3543 10.6409L7.929 12.263C8.0833 12.4212 8.2806 12.5062 8.5115 12.4896C8.7322 12.4769 8.9275 12.3734 9.0623 12.1976L13.5892 6.3021C13.8412 5.974 14.3138 5.9125 14.6405 6.1644C14.9691 6.4164 15.0311 6.887 14.7787 7.2161Z" fill="#000" />
          </svg> <p>Face verification completed</p></div>
          <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
            <img src={faceImgUrl} alt="recaptureimage"/>
          </div>
        </Modal>
      {/* Verification image */}
      {/* <Modal
          title="Face Capture"
          open={true}
          className="customModal sizeMD customerbutton"
          centered
          footer={[
            <div className={styles.poweredsvgbtn}>
              <button>Recapture</button>
              <div className={styles.sendrequest}>
                <button>Cancel</button>
                <button>Start</button>
              </div>
            </div>
          ]}
        >
          <div className={styles.smsotpcontainersvg}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.4771 0 0 4.4771 0 10C0 15.5229 4.4772 20 10 20C15.5228 20 20 15.5227 20 10C20 4.4773 15.5228 0 10 0ZM14.7787 7.2161L10.2518 13.1116C9.8539 13.6302 9.2513 13.9485 8.5985 13.9866C8.555 13.9895 8.5111 13.9905 8.4676 13.9905C7.8607 13.9905 7.2786 13.7464 6.8529 13.3079L5.2782 11.6858C4.9896 11.3889 4.9965 10.9133 5.2938 10.6253C5.5911 10.3373 6.0663 10.345 6.3543 10.6409L7.929 12.263C8.0833 12.4212 8.2806 12.5062 8.5115 12.4896C8.7322 12.4769 8.9275 12.3734 9.0623 12.1976L13.5892 6.3021C13.8412 5.974 14.3138 5.9125 14.6405 6.1644C14.9691 6.4164 15.0311 6.887 14.7787 7.2161Z" fill="#000" />
          </svg> <p>Face verification completed</p></div>
          <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
            <img src={Recapture} alt="recaptureimage"/>
          </div>
        </Modal> */}
      {/* success image */}
      {/* <Modal
           title="Face Capture"
          open={true}
          className="customModal sizeMD customerbutton"
          centered
          footer={[
          ]}
        >
         <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
           <span class="loadercollection"></span>

           <h3>Your information is being verified, please wait...</h3>
         </div>

          <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
         <img src={Success} alt='successmsg'/>

         <h3>Finished learning</h3>
         </div>
        </Modal> */}
      {/* loadermodal */}
      {/* <Modal
           title="Face Capture"
          open={true}
          className="customModal sizeMD customerbutton"
          centered
          footer={[
          ]}
        >
         <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
           <span className="loadercollection"></span>

           <h3>Your information is being verified, please wait...</h3>
         </div>

        
        </Modal> */}
      {/* documentmodal */}
       <Modal
        open={(isFaceDocs || isDocs) && docModal && currdeviceinfo.conId !== customerdetails[0].conId}
        className="customModal sizeMD customerbutton"
        centered
        footer={[
          <div className={styles.poweredsvgbtn}>
            <p>Powered by<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M14.0002 2.54995V9.35183H9.29819V7.25073C9.29819 5.84337 8.156 4.70134 6.74788 4.70134H4.64648V0H11.4499C12.858 0 14.0002 1.14148 14.0002 2.54995Z" fill="#e6e4eb" />
              <path d="M9.29891 9.35156V13.9998L4.64941 9.35156H9.29891Z" fill="#e6e4eb" />
              <path d="M9.29844 7.25008C9.29844 5.84216 8.1568 4.70068 6.74868 4.70068H4.64729L4.64895 4.70234H0V9.35062H4.64895V4.70289L9.29789 9.35117V7.25008H9.29844Z" fill="black" />
            </svg><svg xmlns="http://www.w3.org/2000/svg" width="57" height="12" viewBox="0 0 57 12" fill="none">
                <path d="M10.819 0.84082L9.34378 6.16544L7.97923 1.03437H5.60014L4.23559 6.16544L2.73256 0.84082H0.27832L3.13198 11.0487H4.95161L6.78934 5.79297L8.61315 11.0487H10.4467L13.3004 0.84082H10.819ZM15.7094 4.0413C13.7513 4.0413 12.1522 5.64119 12.1522 7.60033C12.1522 9.55947 13.7513 11.1594 15.7094 11.1594C17.6675 11.1594 19.2665 9.55947 19.2665 7.60033C19.2665 5.64119 17.6675 4.0413 15.7094 4.0413ZM15.7094 8.92452C14.9787 8.92452 14.3859 8.33135 14.3859 7.60033C14.3859 6.86931 14.9787 6.27614 15.7094 6.27614C16.44 6.27614 17.0329 6.86931 17.0329 7.60033C17.0329 8.33135 16.44 8.92452 15.7094 8.92452ZM34.4262 1.95824H32.1925V8.13781C32.1925 10.1519 33.2126 11.048 34.9912 11.048H36.3008V8.81313H35.0601C34.6739 8.81313 34.4262 8.53743 34.4262 8.16496V6.09582H36.3843V4.15061H34.4262V1.95754V1.95824ZM51.839 4.1513H49.9637V4.46878C49.4397 4.19238 48.8886 4.04061 48.2818 4.04061C46.3244 4.04061 44.7393 5.62657 44.7393 7.58571C44.7393 9.54485 46.3244 11.1587 48.2818 11.1587C48.9158 11.1587 49.4676 10.979 49.9915 10.7166V11.048H52.2718V9.02756H51.839V4.1513ZM48.3361 8.92383C47.6062 8.92383 47.0265 8.33066 47.0265 7.58571C47.0265 6.84077 47.6055 6.26082 48.3361 6.26082C49.0668 6.26082 49.6603 6.85399 49.6603 7.58571C49.6603 8.31743 49.0675 8.92383 48.3361 8.92383ZM55.9341 8.81313C55.6028 8.81313 55.4372 8.59243 55.4372 8.27496V1.39292H52.7714V3.41332H53.2043V8.24781C53.2043 10.193 53.9071 11.048 55.8652 11.048H56.4024V8.81313H55.9334H55.9341ZM21.6693 4.46808V4.15061H19.5275V6.17101H19.9603V11.0473H22.1661V7.07469C22.1661 6.62007 22.5391 6.26082 22.9935 6.26082H23.9029V4.15061H22.9107C22.4827 4.15061 22.0694 4.21953 21.6693 4.46808ZM31.5002 4.15061H28.8532L26.9688 5.98512V1.39292H24.3037V3.41332H24.7359V11.048H26.9695V9.0756L27.403 8.65509L29.1433 11.048H31.8453L28.8949 7.15824L31.5002 4.1513V4.15061ZM41.7604 8.10926C41.7604 8.56458 41.3881 8.93706 40.933 8.93706C40.478 8.93706 40.1064 8.56389 40.1064 8.10926V4.15061H37.4531V6.17101H37.8873V8.10926C37.8873 9.792 39.2519 11.158 40.9337 11.158C42.6156 11.158 43.9808 9.792 43.9808 8.10926V4.15061H41.7611V8.10926H41.7604Z" fill="black" />
              </svg></p>
              <div className={styles.sendrequest}>
                <button onClick={cancelModalConfirm}>Cancel</button>
                <button className={doc === "" ? styles.disabled : ""} onClick={getStarted}>Get started</button>
              </div>
          </div>
        ]}
      >
        <div className={styles.collectionpro}>
          <h3>Select a document for verification</h3>
          <div className={doc === "aadhar" ?`${styles.verificationdocument} ${styles.active}` : styles.verificationdocument}  onClick={()=>setDocType('aadhaar')}>
            <div className={styles.verificationdocumentwidth}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                <path d="M15.3518 5.58206C15.3518 4.74126 14.9748 3.94146 14.3179 3.38826L11.7931 1.26226C11.2427 0.798857 10.5369 0.543457 9.80616 0.543457H3.91636C2.11096 0.543457 0.647461 1.95506 0.647461 3.69576V16.3032C0.647461 18.0439 2.11076 19.4551 3.91586 19.4551L12.0834 19.4561C13.8886 19.4561 15.3528 18.045 15.3526 16.3038L15.3518 5.58206ZM13.3516 4.53566C13.4727 4.63776 13.567 4.75976 13.6462 4.88916H12.6505C11.6612 4.88916 10.8258 4.33736 10.8258 3.68406V2.40916L10.8269 2.40966L13.3516 4.53566ZM13.354 17.4532C13.0176 17.7774 12.5663 17.9561 12.0834 17.9561L3.91576 17.9551C2.94066 17.9551 2.14736 17.2139 2.14736 16.3032V3.69586C2.14736 2.78476 2.94096 2.04356 3.91626 2.04356H9.32566V3.68416C9.32566 5.17536 10.8174 6.38926 12.6504 6.38926H13.8518L13.8525 16.3039C13.8525 16.7351 13.6755 17.1432 13.354 17.4532Z" fill="#575CFF" />
                <path d="M11.1998 8.10896H4.80036C4.52396 8.10896 4.30036 8.33256 4.30036 8.60896C4.30036 8.88536 4.52396 9.10896 4.80036 9.10896H11.1998C11.4762 9.10896 11.6998 8.88536 11.6998 8.60896C11.6998 8.33256 11.4762 8.10896 11.1998 8.10896Z" fill="#575CFF" />
                <path d="M10.2853 10.5318H4.80036C4.52396 10.5318 4.30036 10.7554 4.30036 11.0318C4.30036 11.3082 4.52396 11.5318 4.80036 11.5318H10.2853C10.5617 11.5318 10.7853 11.3082 10.7853 11.0318C10.7853 10.7554 10.5617 10.5318 10.2853 10.5318Z" fill="#575CFF" />
                <path d="M9.37116 12.9537H4.80036C4.52396 12.9537 4.30036 13.1773 4.30036 13.4537C4.30036 13.7301 4.52396 13.9537 4.80036 13.9537H9.37116C9.64756 13.9537 9.87116 13.7301 9.87116 13.4537C9.87116 13.1773 9.64756 12.9537 9.37116 12.9537Z" fill="#575CFF" />
              </svg>
              <p>National ID card</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
              <path d="M0.847607 11.6653C0.655207 11.6653 0.462808 11.5921 0.316408 11.4446C0.0239078 11.1516 0.0249076 10.677 0.318408 10.3841L4.18271 6.53165C4.32481 6.39005 4.40291 6.20055 4.40291 5.99945C4.40291 5.79925 4.32481 5.61075 4.18271 5.46915L0.318008 1.61565C0.025008 1.32265 0.0241079 0.848048 0.316508 0.555148C0.608508 0.261248 1.08361 0.261248 1.37751 0.553148L5.24181 4.40665C5.66761 4.83145 5.90241 5.39685 5.90291 5.99945C5.90341 6.60205 5.66851 7.16745 5.24181 7.59415L1.37711 11.4466C1.23111 11.5921 1.03901 11.6653 0.847607 11.6653Z" fill="black" />
            </svg>
          </div>
          <div className={doc === "license" ?`${styles.verificationdocument} ${styles.active}` : styles.verificationdocument} onClick={()=>setDocType('license')}>
            <div className={styles.verificationdocumentwidth}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                <path d="M15.3518 5.58206C15.3518 4.74126 14.9748 3.94146 14.3179 3.38826L11.7931 1.26226C11.2427 0.798857 10.5369 0.543457 9.80616 0.543457H3.91636C2.11096 0.543457 0.647461 1.95506 0.647461 3.69576V16.3032C0.647461 18.0439 2.11076 19.4551 3.91586 19.4551L12.0834 19.4561C13.8886 19.4561 15.3528 18.045 15.3526 16.3038L15.3518 5.58206ZM13.3516 4.53566C13.4727 4.63776 13.567 4.75976 13.6462 4.88916H12.6505C11.6612 4.88916 10.8258 4.33736 10.8258 3.68406V2.40916L10.8269 2.40966L13.3516 4.53566ZM13.354 17.4532C13.0176 17.7774 12.5663 17.9561 12.0834 17.9561L3.91576 17.9551C2.94066 17.9551 2.14736 17.2139 2.14736 16.3032V3.69586C2.14736 2.78476 2.94096 2.04356 3.91626 2.04356H9.32566V3.68416C9.32566 5.17536 10.8174 6.38926 12.6504 6.38926H13.8518L13.8525 16.3039C13.8525 16.7351 13.6755 17.1432 13.354 17.4532Z" fill="#575CFF" />
                <path d="M11.1998 8.10896H4.80036C4.52396 8.10896 4.30036 8.33256 4.30036 8.60896C4.30036 8.88536 4.52396 9.10896 4.80036 9.10896H11.1998C11.4762 9.10896 11.6998 8.88536 11.6998 8.60896C11.6998 8.33256 11.4762 8.10896 11.1998 8.10896Z" fill="#575CFF" />
                <path d="M10.2853 10.5318H4.80036C4.52396 10.5318 4.30036 10.7554 4.30036 11.0318C4.30036 11.3082 4.52396 11.5318 4.80036 11.5318H10.2853C10.5617 11.5318 10.7853 11.3082 10.7853 11.0318C10.7853 10.7554 10.5617 10.5318 10.2853 10.5318Z" fill="#575CFF" />
                <path d="M9.37116 12.9537H4.80036C4.52396 12.9537 4.30036 13.1773 4.30036 13.4537C4.30036 13.7301 4.52396 13.9537 4.80036 13.9537H9.37116C9.64756 13.9537 9.87116 13.7301 9.87116 13.4537C9.87116 13.1773 9.64756 12.9537 9.37116 12.9537Z" fill="#575CFF" />
              </svg>
              <p>Driving License</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
              <path d="M0.847607 11.6653C0.655207 11.6653 0.462808 11.5921 0.316408 11.4446C0.0239078 11.1516 0.0249076 10.677 0.318408 10.3841L4.18271 6.53165C4.32481 6.39005 4.40291 6.20055 4.40291 5.99945C4.40291 5.79925 4.32481 5.61075 4.18271 5.46915L0.318008 1.61565C0.025008 1.32265 0.0241079 0.848048 0.316508 0.555148C0.608508 0.261248 1.08361 0.261248 1.37751 0.553148L5.24181 4.40665C5.66761 4.83145 5.90241 5.39685 5.90291 5.99945C5.90341 6.60205 5.66851 7.16745 5.24181 7.59415L1.37711 11.4466C1.23111 11.5921 1.03901 11.6653 0.847607 11.6653Z" fill="black" />
            </svg>
          </div>
          <div className={doc === "passport" ?`${styles.verificationdocument} ${styles.active}` : styles.verificationdocument} onClick={()=>setDocType('passport')}>
            <div className={styles.verificationdocumentwidth}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                <path d="M15.3518 5.58206C15.3518 4.74126 14.9748 3.94146 14.3179 3.38826L11.7931 1.26226C11.2427 0.798857 10.5369 0.543457 9.80616 0.543457H3.91636C2.11096 0.543457 0.647461 1.95506 0.647461 3.69576V16.3032C0.647461 18.0439 2.11076 19.4551 3.91586 19.4551L12.0834 19.4561C13.8886 19.4561 15.3528 18.045 15.3526 16.3038L15.3518 5.58206ZM13.3516 4.53566C13.4727 4.63776 13.567 4.75976 13.6462 4.88916H12.6505C11.6612 4.88916 10.8258 4.33736 10.8258 3.68406V2.40916L10.8269 2.40966L13.3516 4.53566ZM13.354 17.4532C13.0176 17.7774 12.5663 17.9561 12.0834 17.9561L3.91576 17.9551C2.94066 17.9551 2.14736 17.2139 2.14736 16.3032V3.69586C2.14736 2.78476 2.94096 2.04356 3.91626 2.04356H9.32566V3.68416C9.32566 5.17536 10.8174 6.38926 12.6504 6.38926H13.8518L13.8525 16.3039C13.8525 16.7351 13.6755 17.1432 13.354 17.4532Z" fill="#575CFF" />
                <path d="M11.1998 8.10896H4.80036C4.52396 8.10896 4.30036 8.33256 4.30036 8.60896C4.30036 8.88536 4.52396 9.10896 4.80036 9.10896H11.1998C11.4762 9.10896 11.6998 8.88536 11.6998 8.60896C11.6998 8.33256 11.4762 8.10896 11.1998 8.10896Z" fill="#575CFF" />
                <path d="M10.2853 10.5318H4.80036C4.52396 10.5318 4.30036 10.7554 4.30036 11.0318C4.30036 11.3082 4.52396 11.5318 4.80036 11.5318H10.2853C10.5617 11.5318 10.7853 11.3082 10.7853 11.0318C10.7853 10.7554 10.5617 10.5318 10.2853 10.5318Z" fill="#575CFF" />
                <path d="M9.37116 12.9537H4.80036C4.52396 12.9537 4.30036 13.1773 4.30036 13.4537C4.30036 13.7301 4.52396 13.9537 4.80036 13.9537H9.37116C9.64756 13.9537 9.87116 13.7301 9.87116 13.4537C9.87116 13.1773 9.64756 12.9537 9.37116 12.9537Z" fill="#575CFF" />
              </svg>
              <p>Passport</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
              <path d="M0.847607 11.6653C0.655207 11.6653 0.462808 11.5921 0.316408 11.4446C0.0239078 11.1516 0.0249076 10.677 0.318408 10.3841L4.18271 6.53165C4.32481 6.39005 4.40291 6.20055 4.40291 5.99945C4.40291 5.79925 4.32481 5.61075 4.18271 5.46915L0.318008 1.61565C0.025008 1.32265 0.0241079 0.848048 0.316508 0.555148C0.608508 0.261248 1.08361 0.261248 1.37751 0.553148L5.24181 4.40665C5.66761 4.83145 5.90241 5.39685 5.90291 5.99945C5.90341 6.60205 5.66851 7.16745 5.24181 7.59415L1.37711 11.4466C1.23111 11.5921 1.03901 11.6653 0.847607 11.6653Z" fill="black" />
            </svg>
          </div>
        </div>
      </Modal>


      {/* cancelverification */}
      <Modal
          title="Cancel verification"
          open={cancelModal}
          className="customModal sizeMD customerbutton"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16"  onClick={()=>{setCancelModal(false)}}></span>}
          footer={[
            <div className={`${styles.poweredsvgbtn} ${styles.poweredsvgbtnstart}`}>
              <div className={`${styles.sendrequest} `}>
                <button className={styles.sendrequestyescl} onClick={()=>{setCancelModal(false)}}>Cancel</button>
                <button className={styles.sendrequestyes} onClick={cancelModalConfirm}>Yes</button>
              </div>
            </div>
          ]}
        >
          <div className={styles.verificationwant}>
            <h3>Are you sure want to cancel face verification ?</h3>
          </div>
        </Modal>
      {/* Document upload */}

      <Modal
          title="Document Capture"
          open={(isDocs || isFaceDocs) && docCaptureModal}
          className="customModal sizeMD customerbutton"
          centered
          closeIcon={customerdetails[0]?.conId !== currdeviceinfo.conId ? <span className="icon__Close16" onClick={cancelModalConfirm}></span> : null}
          footer={customerdetails[0]?.conId !== currdeviceinfo.conId ? [
            <div className={`${styles.poweredsvgbtn} ${styles.poweredsvgbtnstart}`}>
            <div className={`${styles.sendrequest} `}>
              <button  onClick={cancelModalConfirm}>Cancel</button>
              <button onClick={docCapture}>Capture</button>
            </div>
          </div>
          ] : null}
        >
          <div className={styles.verificationwant}>
                      <video
                                     playsInline
                                     autoPlay
                                     ref={participantVideo}
                                     id={customerdetails[0]?.conId}
                                     preload={"auto"}
                                     style={{ display: currdeviceinfo.video ? "block" : "none"} }
                                     muted={true}
                                 />
                        { <canvas id="canvaverification" ref={canvasRef} style={{display:"none"}}></canvas>}
          </div>
          {currdeviceinfo?.conId === customerdetails[0]?.conId && <div className={`${styles.poweredsvgbtn} ${styles.poweredinstruct}`}>
             <p onClick={()=>setIsInstruction(!isInstruction)}><svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
            <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676"/>
            </svg>Instructions</p>

            {isInstruction && <div className={styles.documentinst}>
               <p><span>1</span>Take a photo of the frontside of your national ID card.</p>
               <p><span>2</span>Don't fold the document</p>
               <p><span>3</span>Show entire document</p>
               <p><span>4</span> Avoid glare</p>
               <p><span>5</span> No paper-based documents</p>
               <p><span>6</span> No photocopy or black & white document</p>
               <p><span>7</span> No image from another image or device</p>
            </div>}
            </div>}
        </Modal>

     
      <Modal
          title="Document capture"
          open={((isDocs || isFaceDocs) && customerdetails[0]?.conId !== currdeviceinfo.conId && docDetailsModal && isStore && !_.isEmpty(docReceiveDetails) ) || ((isDocs || isFaceDocs) &&  docDetailsModal && isVerify && !_.isEmpty(docReceiveDetails))}
          className="customModal sizeMD customerbutton verifytableuc"
          centered
          destroyOnClose={true}
          closeIcon={customerdetails[0]?.conId !== currdeviceinfo.conId ? <span className="icon__Close16" onClick={cancelModalConfirm}></span> : null}
          footer={customerdetails[0]?.conId !== currdeviceinfo.conId ? [
            <div className={`${styles.poweredsvgbtn} ${styles.poweredsvgbtnstart}`}>
            <div className={`${styles.sendrequest} `}>
              {(!dataProcessing) && <button className={(isVerify && docReceiveDetails?.status === "notverified") ? `${styles.complete} ${styles.disabled}` : `${styles.complete}`} onClick={isStore ? ()=>uploadImage(imgFile.file1,doc) : completeVerification}>{isVerify ? 'Complete Verification' : 'Save'}</button>}
            </div>
          </div>
          ] : null}
        >

          {/* Extracting document details, please wait... */}
                  { dataProcessing && isStore  && verifyContent==="Extracting document details" &&  <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
           <span className="loadercollection"></span>
           <h3>Extracting document details, please wait...</h3>
         </div>}

         {verifyContent=== "Data extraction completed."   &&  isStore && <div className={`${styles.collectionpro} ${styles.collectionproverified}`}>
         <img src={Success} alt='successmsg'/>

          <h3>Data extraction completed.</h3>
         </div>}
          {isFaceDocs && !dataProcessing &&  <div className={styles.detailsmaincontent}>
            <div className={styles.customername}>
              <img src={faceImgUrl} alt="" />
            </div>
            <div className={styles.rightdetails}>
            <div className={styles.customleft}>
              <label>Customer name</label>
              <p>{`${meetingDetails?.agentDetails?.customerDetails?.firstName} ${meetingDetails?.agentDetails?.customerDetails?.lastName} `}</p>
            </div>
            <div className={styles.customleft}>
              <label>Phone number</label>
              <p>{meetingDetails?.agentDetails?.customerNumber}</p>
            </div>
            {/* <div className={styles.customleft}>
              <label>Live GPS location</label>
              <p>Bobcat Lane</p>
            </div>
            <div className={styles.customleft}>
              <label>Device details</label>
              <p>Asus Rog 5</p>
            </div>
            <div className={styles.customleft}>
              <label>Browser details with IP address</label>
              <p>192.158.1.38</p>
            </div> */}
            <div className={styles.customleft}>
              <label>Email address</label>
              <p>{JSON.parse(meetingDetails?.agentDetails?.customerDetails?.email)[0]}</p>
            </div>
            </div>
          </div>}
         {!dataProcessing &&  <div className={styles.verificationwant}>
            <div className='tabledocument'>
        <table className="table">
        <thead>
          <tr>
            <th>Document</th>
            <th>Title</th>
            <th>Extracted Data</th>
            <th>Status</th>

          </tr>
        </thead>
        <tbody>
            <tr>
              <td><img id="img" className={styles.imagetable} src={docImgUrl}></img></td>
              <td>{docSendDetails.type}</td>
              {docReceiveDetails?.data &&<td>
              {Object.entries(docReceiveDetails.data).map(([key, value]) => {
                return (<div>{`${key} : ${value}`}</div>)
                })}
                </td>}
              <td>
                 {docReceiveDetails?.status && <div> {docReceiveDetails.status} </div>}
                  {isVerify && <div className={styles.rescandetails}>
                    {/* <p><svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
  <path d="M6.99993 2.63347C6.76067 2.63347 6.56667 2.82747 6.56667 3.06673V7.5332C6.56667 7.7728 6.76067 7.9668 6.99993 7.9668C7.2392 7.9668 7.4332 7.7728 7.4332 7.5332V3.06673C7.4332 2.82747 7.2392 2.63347 6.99993 2.63347Z" fill="#DE003D"/>
  <path d="M6.83327 8.5332C6.77987 8.5534 6.733 8.5866 6.69327 8.62627C6.6132 8.70633 6.56633 8.8196 6.56633 8.93293C6.56633 8.99347 6.57967 9.0462 6.59987 9.0996C6.61973 9.153 6.65327 9.19987 6.69327 9.2396C6.733 9.27993 6.77987 9.3132 6.83327 9.33333C6.88633 9.35353 6.94653 9.36653 6.99993 9.36653C7.0598 9.36653 7.1132 9.35353 7.1666 9.33333C7.21967 9.31313 7.26653 9.27993 7.3066 9.2396C7.34667 9.19987 7.37987 9.153 7.39967 9.0996C7.41987 9.0462 7.4332 8.99347 7.4332 8.93293C7.4332 8.81967 7.38633 8.7064 7.3066 8.62627C7.18647 8.50647 6.99313 8.46673 6.83327 8.5332Z" fill="#DE003D"/>
  <path d="M13.2666 8.73333L8.8666 1.06667C8.4666 0.4 7.73327 0 6.99993 0C6.2666 0 5.53327 0.333333 5.13327 1.06667L0.733268 8.73333C-0.133399 10.2 0.933268 12 2.59993 12H11.3999C13.0666 12 14.1333 10.2 13.2666 8.73333ZM12.5333 10.5333C12.2666 10.9333 11.8666 11.2 11.3999 11.2H2.59993C2.13327 11.2 1.73327 10.9333 1.4666 10.5333C1.2666 10.1333 1.2666 9.6 1.4666 9.2L5.8666 1.53333C6.13327 1.13333 6.53327 0.866667 6.99993 0.866667C7.4666 0.866667 7.8666 1.13333 8.13327 1.53333L12.5333 9.2C12.7999 9.6 12.7999 10.1333 12.5333 10.5333Z" fill="#DE003D"/>
</svg> Modified 
Document</p> */}

                    {docReceiveDetails?.status === "notverified" && customerdetails[0]?.conId !== currdeviceinfo.conId && <button onClick={()=>setDocType(docSendDetails?.type)}>Re-Scan</button>}</div>}
                </td>
                 </tr>

           
        </tbody>
      </table>
      </div>
          </div>}
        </Modal>
    </>
  )
}
export default Verificationmodal;